import { faBars, faPenToSquare, faRotateRight, faTrash } from '@fortawesome/free-solid-svg-icons';
import type { IconDefinition } from '@fortawesome/fontawesome-svg-core';
import type { ReactElement } from 'react';
import type {
  DropdownItem,
  ModalConfig,
  TopBarElement,
  UnifiedTopBarProps,
} from '@frontend/Models/TopBar/TopBarModels';

export interface DetailViewTemplateOptions {
  onEdit?: () => void;
  onDelete?: () => void;
  onRefresh?: () => void;
  editAriaLabel?: string;
  deleteAriaLabel?: string;
  refreshAriaLabel?: string;
  editIcon?: IconDefinition;
  deleteIcon?: IconDefinition;
  refreshIcon?: IconDefinition;
  dropdown?: {
    items: DropdownItem[];
    ariaLabel?: string;
    icon?: IconDefinition;
  };
  leftExtras?: (TopBarElement | ReactElement)[];
  rightExtras?: (TopBarElement | ReactElement)[];
  modals?: ModalConfig[];
  className?: string;
  pageContext?: Record<string, any>;
}

export function createDetailViewTemplate(options: DetailViewTemplateOptions): UnifiedTopBarProps {
  const leftElements: (TopBarElement | ReactElement)[] = [];
  const rightElements: (TopBarElement | ReactElement)[] = [];

  if (options.onEdit) {
    leftElements.push({
      type: 'button',
      icon: options.editIcon ?? faPenToSquare,
      onClick: options.onEdit,
      ariaLabel: options.editAriaLabel ?? 'Edit record',
    });
  }

  if (options.onDelete) {
    leftElements.push({
      type: 'button',
      icon: options.deleteIcon ?? faTrash,
      onClick: options.onDelete,
      ariaLabel: options.deleteAriaLabel ?? 'Delete record',
    });
  }

  if (options.onRefresh) {
    leftElements.push({
      type: 'button',
      icon: options.refreshIcon ?? faRotateRight,
      onClick: options.onRefresh,
      ariaLabel: options.refreshAriaLabel ?? 'Refresh data',
    });
  }

  if (options.leftExtras?.length) {
    leftElements.push(...options.leftExtras);
  }

  if (options.rightExtras?.length) {
    rightElements.push(...options.rightExtras);
  }

  if (options.dropdown) {
    rightElements.push({
      type: 'dropdown',
      trigger: {
        icon: options.dropdown.icon || faBars,
        ariaLabel: options.dropdown.ariaLabel ?? 'More actions',
      },
      items: options.dropdown.items,
    });
  }

  return {
    leftElements,
    rightElements,
    modals: options.modals ?? [],
    className: options.className,
    pageContext: options.pageContext,
  };
}
